import type { MetaWindow } from '../../services/MetaMessagesService';

/** Texto da janela fechada do WhatsApp oficial (a mesma frase que o servidor devolve no 409). */
export const WHATSAPP_WINDOW_CLOSED_TEXT = 'Fora das 24 h do WhatsApp: use um modelo aprovado.';

const WINDOW_MS = 24 * 3600_000;

export type WhatsAppWindow = Pick<MetaWindow, 'state' | 'untilUtc'>;

/**
 * Janela de atendimento de 24 h, igual à da Meta: aberta pela última mensagem do CLIENTE e renovada a cada nova. O que a
 * empresa envia, inclusive pelo app do celular, não abre nem estende. O servidor é quem decide no envio (409); aqui é só o aviso.
 */
export function whatsAppWindowOf(
  messages: ReadonlyArray<{ isSent: boolean; sentAt: string }>,
  now: Date = new Date(),
): WhatsAppWindow {
  let last: number | null = null;
  for (const m of messages) {
    if (m.isSent) continue;
    const at = new Date(m.sentAt).getTime();
    if (!isNaN(at) && (last === null || at > last)) last = at;
  }
  if (last === null || last + WINDOW_MS <= now.getTime()) return { state: 'closed', untilUtc: null };
  return { state: 'open', untilUtc: new Date(last + WINDOW_MS).toISOString() };
}

/** Texto do compositor travado: fora das 24 h só vale um modelo aprovado. */
export const WHATSAPP_TEMPLATE_ONLY_TEXT = 'Fora das 24 h só é possível enviar um modelo aprovado';

/**
 * O compositor livre (texto, mídia e voz) fica desabilitado quando o setor é Cloud, a conversa é de WhatsApp e a janela fechou:
 * o servidor responderia 409. Sobra só "Enviar modelo". Conversa ainda carregando nunca trava.
 */
export function whatsAppComposerLocked(opts: {
  active: boolean;
  messages: ReadonlyArray<{ isSent: boolean; sentAt: string }>;
  loading?: boolean;
  now?: Date;
}): boolean {
  if (!opts.active || (opts.loading && opts.messages.length === 0)) return false;
  return whatsAppWindowOf(opts.messages, opts.now).state === 'closed';
}
